/**
 * Hộp thoại xác nhận cho thao tác nguy hiểm (OQ-231).
 *
 * Chủ dự án bấm "Tạm dừng Cloudflare" và thao tác chạy **ngay** — tắt CDN/WAF
 * cho cả tên miền, không một câu hỏi nào. Rà ra ba nút cùng dạng: tạm dừng
 * zone, đặt lại vai trò về mặc định, đăng xuất mọi thiết bị khác.
 *
 * ── Vì sao không dùng `ConfirmName` ────────────────────────────────────
 *
 * `ConfirmName` bắt gõ đúng tên trước khi cho bấm — đúng cho **xoá vĩnh viễn**,
 * quá nặng cho những việc hoàn tác được bằng một cú bấm khác. Bắt gõ tên cho
 * mọi thứ sẽ dạy người dùng chép-dán mà không đọc, và khi ấy rào chắn thật sự
 * (xoá tên miền) mất luôn tác dụng.
 *
 * Ở đây chỉ cần một nhịp dừng: nói rõ **điều gì sắp xảy ra** và **cách quay
 * lại**, rồi để họ bấm.
 */

import type { ReactNode } from 'react';
import { Modal } from './Modal';
import { Icon } from './Icon';
import { useT } from '../lib/i18n';

export function ConfirmDialog({
  open,
  title,
  message,
  /** Dòng nói cách hoàn tác — bỏ trống khi thao tác KHÔNG hoàn tác được. */
  undoNote,
  confirmLabel,
  danger = false,
  busy = false,
  odId,
  onCancel,
  onConfirm,
  children,
}: {
  open: boolean;
  title: string;
  message: string;
  undoNote?: string | undefined;
  confirmLabel: string;
  danger?: boolean;
  busy?: boolean;
  odId?: string;
  onCancel: () => void;
  onConfirm: () => void;
  children?: ReactNode;
}) {
  const t = useT();
  if (!open) return null;

  return (
    <Modal
      open
      title={title}
      onClose={() => {
        /* Bấm ra ngoài / Esc = HUỶ, không phải xác nhận. Mặc định phải là
         * lựa chọn không gây hại. */
        if (!busy) onCancel();
      }}
      footer={
        <>
          <button className="btn" type="button" disabled={busy} onClick={onCancel}>
            {t('common.cancel')}
          </button>
          <button
            className={danger ? 'btn btn-danger' : 'btn btn-primary'}
            type="button"
            disabled={busy}
            onClick={onConfirm}
            data-od-id={odId ? `${odId}-confirm` : 'confirm-yes'}
          >
            {busy ? t('common.processing') : confirmLabel}
          </button>
        </>
      }
    >
      <div {...(odId ? { 'data-od-id': odId } : {})}>
        <div className={danger ? 'scope-note warn' : 'scope-note'}>
          <Icon name={danger ? 'warn' : 'info'} size={17} />
          <span>{message}</span>
        </div>
        {undoNote ? <p className="hint">{undoNote}</p> : null}
        {children}
      </div>
    </Modal>
  );
}
